export default __webpack_public_path__ + "pgnv-assets/57948e5b84b287f0eb055a3b1908dde2.png";